import { Stack } from "@mui/material";
import { useGenerateIndependentContractorBadge } from "@src/appV2/Agents/components/ContractorBadge/use-generate-independent-contractor-badge";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

interface IndependentContractorBadgeShowButtonProps {
  licenseNumber: string | undefined;
  qualification: string;
  buttonVariant?: "outlined" | "contained";
}

export function IndependentContractorBadgeShowButton({
  licenseNumber,
  qualification,
  buttonVariant,
}: IndependentContractorBadgeShowButtonProps) {
  const { mutateAsync: generateAndShareBadge, isLoading: isContractorBadgeLoading } =
    useGenerateIndependentContractorBadge();

  return (
    <Stack spacing={4} sx={{ alignItems: "center" }}>
      <LoadingButton
        fullWidth
        size="large"
        variant={buttonVariant ?? "outlined"}
        isLoading={isContractorBadgeLoading}
        onClick={async () => {
          await generateAndShareBadge({
            licenseNumber,
            qualification,
          });
        }}
      >
        Show {qualification} Badge
      </LoadingButton>
    </Stack>
  );
}
